import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { AlertBox } from "shared/dist/components";
import Actions from "./Actions";
import DemoCreationComponent from "./DemoCreationComponent";
import { aiServiceDetailsActions } from "../../../Services/Redux/actionCreators";
import classes from "./Demo.module.css";
import FormContentCard from "../../../Components/PageFormComponents/FormContentCard";
import { demoAlerts } from "./DemoFilesStatus";

const Demo = () => {
    const dispatch = useDispatch();
    const serviceDetails = useSelector((state) => state.aiServiceDetails);
    const orgUuid = useSelector((state) => state.organization.selectedOrganizationUuid);
    const organization = useSelector((state) => state.organization);
    const demoFilesStatus = serviceDetails.assets.demoFiles.status;
    const [notification, setNotification] = useState({});
    const [selectedFile, setSelectedFile] = useState({ name: "", size: "", type: "" });

    useEffect(() => {
        setNotification(demoAlerts[demoFilesStatus]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [demoFilesStatus]);

    const handleCheckboxChange = async () => {
        await dispatch(
            aiServiceDetailsActions.saveServiceDetails(
                orgUuid,
                {
                    ...serviceDetails,
                    demoComponentAvailable: !serviceDetails.demoComponentAvailable,
                },
                true
            )
        );
        await dispatch(
            aiServiceDetailsActions.getServiceDetails(orgUuid, serviceDetails.uuid, organization.id)
        );
    };

    return (
        <Fragment>
            <FormContentCard
                title="Demo Setup"
                titleComponent={
                    <FormControlLabel
                        className={classes.switch}
                        labelPlacement="end"
                        label="Enable Demo"
                        control={
                            <Switch
                                checked={Boolean(serviceDetails.demoComponentAvailable)}
                                onChange={handleCheckboxChange}
                                color="primary"
                            />
                        }
                    />
                }
                description={`
                    AI publishers can create a unique demo experience that users on the AI
                    Marketplace can engage with. A positive demo experience will encourage users
                    to engage and integrate your AI into their applications. We encourage you to
                    follow our best practices on how to properly set up your demo on our AI
                    Marketplace.
                    `}
            >
                {!!serviceDetails.demoComponentAvailable && (
                    <DemoCreationComponent
                        selectedFile={selectedFile}
                        uploadDemoFilesDetails={setSelectedFile}
                    />
                )}
            </FormContentCard>
            {notification && Boolean(serviceDetails.demoComponentAvailable) && (
                <div className={classes.uploadStatusNotification}>
                    <AlertBox type={notification.type} message={notification.message} />
                </div>
            )}
            <Actions selectedFile={selectedFile} />
        </Fragment>
    );
};
export default Demo;
